<template>
  <accordion-section
    :open="section === 1"
    :valid="true"
    @selected="$emit('openSection', 1)"
  >
    <template #heading>
      Profile Picture &amp; Cover Photo
    </template>

    <div class="image_uploads">
      <div class="profile_picture">
        <profile-cover-media-item
          :media-item="profileMediaItem"
          parent="EditListing"
          type="profile"
        />
      </div>

      <div class="cover_photo">
        <profile-cover-media-item
          :media-item="coverMediaItem"
          parent="EditListing"
          type="cover"
        />
      </div>
    </div>

    <div class="recommendations">
      <span>Recommendations</span>
      <ul>
        <li>
          <strong>Profile:</strong> a photo to help customers easily identify your business. Recommended Size – 250 x
          250 pixels (minimum 120 x 120 pixels; maximum 5200 x 5300 pixels)
        </li>
        <li>
          <strong>Cover:</strong> your business’ preferred photo. Though it’s preferred, it doesn’t guarantee that
          this image will populate as the first image on your listing. Recommended Size - 1080 x 608 pixels
          (minimum 480 x 270 pixels; maximum 2120 x 1192 pixels)
        </li>
      </ul>
    </div>
  </accordion-section>
</template>

<script>
import AccordionSection from "../items/AccordionSection";
import {mapGetters} from "vuex";
import ProfileCoverMediaItem from "../items/ProfileCoverMediaItem";

export default {
  components: {
    ProfileCoverMediaItem,
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    ...mapGetters('businessProfile', [
      'profileMediaItem',
      'coverMediaItem',
    ]),
  }
}
</script>

<style lang="scss" scoped>
.image_uploads {
  display: flex;
  align-items: center;
  justify-content: space-between;

  > .profile_picture {
    width: 10rem;
    height: 10rem;
    margin-right: 1.5rem;
  }

  > .cover_photo {
    height: 10rem;
    flex: 1;
  }
}
</style>
